import { DateTime } from 'luxon';

export const breakpoints = {
  sm: 420,
  md: 1000,
};

/**
 * This generates the media query string *without the opening bracket* for
 * everything above the provided breakpoint
 *
 * @param {number} breakpoint
 * @returns {string} mediaQuery
 */
export const aboveBreakpoint = (breakpoint) => `@media (min-width: ${breakpoint}px)`;

/**
 * This generates the media query string *without the opening bracket* for
 * everything below the provided breakpoint
 *
 * @param {number} breakpoint
 * @returns {string} mediaQuery
 */
export const belowBreakpoint = (breakpoint) => `@media (max-width: ${breakpoint}px)`;

/**
 * This generates the media query string *without the opening bracket* for
 * everything between the two provided breakpoints
 *
 * @param {number} startBreakpoint
 * @param {number} endBreakpoint
 * @returns {string} mediaQuery
 */
export const betweenBreakpoints = (startBreakpoint, endBreakpoint) =>
  `@media (max-width: ${endBreakpoint}px) and (min-width: ${startBreakpoint}px)`;

export const getIsInProgress = (subEvent) =>
  +DateTime.fromISO(subEvent.startDate) < +DateTime.now();
